import React, { useEffect, useState } from "react";
import {
	PayPalScriptProvider
} from "@paypal/react-paypal-js";
import GTCSubscriptionButton from "../components/GTCSubscriptionButton";
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { useNavigate, useParams } from "react-router-dom";
import planFeatures from "../libs/planFeatures";
import GTCReminder from "../components/GTCReminder";
import { selectProfile } from "../store/profile";
import { useSelector } from "react-redux";
import { FaCheck, FaRocket, FaLock } from 'react-icons/fa';
import '../css/gtc-checkout.css';

let features = planFeatures.default;

function GTCSingleSubscription () {
    const { service, id, plan }  = useParams();
    const [clientId, setClientId] = useState<string>('');
    const [planId, setPlanId] = useState<string>('');
    const [subscriptionId, setSubscriptionId] = useState<string>('');
    const [planDetails, setPlanDetails] = useState<any>(null);
    const chanId = id;
    const navigate = useNavigate();
    const profile = useSelector(selectProfile);


    features = service == "geo" ? planFeatures.default : planFeatures.rplansFeatures;

    const getChannel = async () => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "getchan",
                data: {
                    id: id
                }
            })
            // console.log(res);
            if (res.status == 200 && !res.data) {
                navigate("/home");
            }
            if (res && res.data && res.data.service && res.data.service != service) {
                navigate("/home");
            }
        } catch (error) {
            console.log("getChannel.subscription", error)
        }
    }

    // console.log("GTCSingleSubscription", profile)
    const numFormat = (limit: number) => {
        if (limit < 1000000) {
            return `${Number((limit / 1000).toFixed(1))}K`
        }
        else {
            return `${Number((limit / 1000000).toFixed(1))}M`
        }
    }

    const getSubsciptionDetails = async () => {
        try {
            const data = await apiRequest({
                method: "GET",
                fn: "subscriptionplandetails",
                api: API_CONSTANTS.PRIVATE_API,
                data: {
                    plan: plan,
                    service: service
                }
            });
            if (data && data.status == 200) {
                const apiData = data.data;
                setClientId(apiData.clientId);
                setPlanDetails(apiData.plan);
            } else {
                navigate(-1);
            }
        } catch (error) {
            console.log("getSubsciptionDetails", error)
        }
    }

    const onSuccessSubscription = async (data: any) => {
        // console.log("onSuccessSubscription", data);
        alert("Successful transaction");
        navigate(`/channel/${id}`);
    }

    useEffect(() =>  {
        getChannel();
        getSubsciptionDetails();
    }, []);

    return (
        <>
            {
                (clientId && planDetails && profile && profile.email) ? (
                    <PayPalScriptProvider options={{
                        clientId: clientId,
                        components: "buttons",
                        intent: "subscription",
                        vault: true}}>
                        <div className='checkout-page'>
                            <div className='container'>
                                <GTCReminder
                                    reminder={"It will be automatically downgraded or upgraded your current plan."}
                                    btnText={"Plans"}
                                />

                                <div className="checkout-container">
                                    <div className="checkout-content">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="plan-details">
                                                    <div className="plan-badge">Selected Plan</div>
                                                    <h1 className="plan-name">{planDetails.title || ""}</h1>
                                                    <p className="plan-description">{planDetails.desc || ""}</p>

                                                    <div className="price-section">
                                                        <div className="price-amount">
                                                            <span className="price-currency">$</span>
                                                            {planDetails.price}
                                                        </div>
                                                        <div className="price-interval">per month</div>
                                                    </div>

                                                    <div className="features-section">
                                                        <div className="features-title">
                                                            <FaRocket className="features-icon" />
                                                            Plan Features
                                                        </div>
                                                        <div className="features-list">
                                                            {features.map((feature, i) => (
                                                                <div key={i} className="feature-item">
                                                                    <FaCheck className="check-icon" />
                                                                    <span className="feature-text">
                                                                        {feature.replace(/{{limit}}/g, numFormat(planDetails.limit))}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="payment-section">
                                                    <h2 className="payment-title">Complete Your Subscription</h2>
                                                    <GTCSubscriptionButton
                                                        planId={planDetails.plan}
                                                        chanId={chanId}
                                                        account={{ uid: profile.uid, email: profile.email }}
                                                        type={"subscription"}
                                                        success={onSuccessSubscription}
                                                    />
                                                    <div className="secure-badge">
                                                        <FaLock className="lock-icon" />
                                                        Secure Payment with PayPal
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PayPalScriptProvider>
                ) : null
            }
        </>
    )
}

export default GTCSingleSubscription;